export class InventoryTypeFieldOptionMessage {
  id: number
  active: boolean
  displayOrder: number
  value: string

  constructor(id: number, active: boolean, displayOrder: number, value: string) {
    this.active = active
    this.id = id
    this.displayOrder = displayOrder
    this.value = value
  }
}
  